import {setToast} from '@assets/actions/layout/setToastAction';
import {store} from '@assets/index';
/**
 * @param {string} text
 * @returns {*}
 */
export default function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    // Trình duyệt hiện đại + HTTPS
    store.dispatch(setToast({content: 'Copied to clipboard'}));
    return navigator.clipboard.writeText(text);
  } else {
    // Fallback cho trình duyệt cũ
    const textarea = document.createElement('textarea');
    textarea.value = text;

    // Không hiển thị textarea lên UI
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      store.dispatch(setToast({content: 'Copied to clipboard'}));
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
